import { useNavigate } from "@tanstack/react-router";

import type { ContractsSearch } from "@/features/contracts";

/**
 * Deep-links from a KPI drawer into the Contracts section's record drawer.
 * The Contracts section keys contracts by their Cinch contract id and accounts
 * by the Cinch account UUID (both carried on the KPI drill-down rows). Opens
 * the record expanded on the matching tab.
 */
export function useContractsRecord() {
  const navigate = useNavigate();
  const open = (tab: ContractsSearch["tab"], detail: string) =>
    navigate({
      to: "/contracts",
      search: (): ContractsSearch => ({ tab, detail, expanded: true }),
    });
  return {
    openContract: (contractId: string | number | null | undefined) =>
      contractId != null && open("contracts", `contracts:${contractId}`),
    openAccount: (accountId: string | null | undefined) =>
      accountId && open("accounts", `accounts:${accountId}`),
  };
}
